export const url = "/api";

const config = {
  api_url: url
};

export default config;
